import React from "react";
import { useEffect, useState } from "react";
import "react-loading-skeleton/dist/skeleton.css";
import { Services } from "../../api/Services";
// Set the locale globally (optional)
import ReactPaginate from "react-paginate";
import gymgirl from "../../images/gymgirl.jpg";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import UserStats from "./UserStats";
import { BASE_URL_MEDIA } from "../../api/Constants";
import { BASE_URL_COMPETITION } from "../../api/Constants";
import { getImageUrl } from "components/helpers/Helpers";

const TrainerGroups = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [groups, setGroups] = useState([]);
  const [pageCount, setPageCount] = useState(0);
  const [members, setMembers] = useState([]);
  const [duplicateMembers, setDuplicateMembers] = useState([]);
  const [duplicateMembersa, setDuplicateMembersa] = useState([]);
  const [memberModal, setMemberModal] = useState(false);
  const [activitymembers, setactivityMembers] = useState([]);
  const [activityModal, setActivityModal] = useState(false);
  const [pageCounta, setPageCounta] = useState(0);
  const [search, setSearch] = useState("");
  const [searcha, setSearcha] = useState("");
  const [userId, setUserId] = useState("");
  const [showModal, setShowModal] = useState(false);
  //api call for get trainer clients

  const filterUser = (e) => {
    setSearch(e.target.value);
    const value = e.target.value;
    const filteredResult = members?.filter((item) =>
      item.name.toLowerCase().includes(value.toLowerCase())
    );
    setMembers(value === "" ? duplicateMembers : filteredResult);
  };
  //api call for get trainer clients

  const filterActivityUser = (e) => {
    setSearcha(e.target.value);
    const value = e.target.value;
    const filteredResult = activitymembers?.filter((item) =>
      item.user.name.toLowerCase().includes(value.toLowerCase())
    );
    setactivityMembers(value === "" ? duplicateMembersa : filteredResult);
  };

  const getTrainerGroups = async () => {
    setIsLoading(true);
    try {
      const result = await Services.getTrainerDashboardGroups();
      console.log(result);
      if (result) {
        setGroups(result?.data?.data?.groups);
      } else {
        toast.error(result.data.message, {
          autoClose: 2000,
          pauseOnHover: true,
          draggable: true,
          position: toast.POSITION.TOP_CENTER,
        });
      }
      setIsLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  // handle page count
  const handlePageClick = (event) => {
    getGroupMembers(event.selected + 1);
  };
  //api call for group members
  const getGroupMembers = async (group_id, pageNumber) => {
    setIsLoading(true);
    try {
      const result = await Services.getTrainerGroupMembers(
        group_id,
        (pageNumber = 1)
      );

      if (result) {
        setMembers(result?.data?.data?.listing);
        setDuplicateMembers(result?.data?.data?.listing);
        setPageCount(result?.data?.data?.paging?.total_pages);
        setMemberModal(true);
      } else {
        toast.error(result.data.message, {
          autoClose: 2000,
          pauseOnHover: true,
          draggable: true,
          position: toast.POSITION.TOP_CENTER,
        });
      }
      setIsLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  // handle page count for activity member
  const handlePageClickActivity = (event) => {
    getActivityMembers(event.selected + 1);
  };
  //api call for group members
  const getActivityMembers = async (activity_id, pageNumber) => {
    setIsLoading(true);
    try {
      const result = await Services.getTrainerActivityeMembers(
        activity_id,
        (pageNumber = 1)
      );

      if (result) {
        setactivityMembers(result?.data?.data?.listing);
        setDuplicateMembersa(result?.data?.data?.listing);
        setPageCounta(result?.data?.data?.paging?.total_pages);
        setActivityModal(true);
      } else {
        toast.error(result.data.message, {
          autoClose: 2000,
          pauseOnHover: true,
          draggable: true,
          position: toast.POSITION.TOP_CENTER,
        });
      }
      setIsLoading(false);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    getTrainerGroups();
  }, []);
  const showUserStats = (id) => {
    //setUserId(id);
    //setShowModal(true);
    const metaToken = localStorage.getItem("token");
    const url = `${BASE_URL_COMPETITION}/user/${id}${metaToken ? "?token=" + metaToken : ""}`;
    window.open(url, "_blank");
  };

  const showGroupProfile = (gid) => {
    //setShowModal(true);
    const metaToken = localStorage.getItem("token");
    const url = `${BASE_URL_COMPETITION}/all-groups?tab=view-members&g-id=/${gid}${metaToken ? "?token=" + metaToken : ""}`;
    window.open(url, "_blank");
  };
  
  return (
    <div className="dashboard-groups-wrapper">
      {userId && showModal && (
        <div className="trainer-modal-eventWrapper trainer-modal-eventWrapper-upper">
          <div className="trainer-modal trainer-modal-lg">
            <div className="close" onClick={() => setShowModal(false)}>
              <i className="fa fa-times"></i>
            </div>
            <UserStats userId={userId} />
          </div>
        </div>
      )}
      {/* Group memers modal */}
      {memberModal && (
        <div className="trainer-modal-eventWrapper">
          <div className="trainer-modal">
            <div className="close" onClick={() => setMemberModal(false)}>
              <i className="fa fa-times"></i>
            </div>
            <div className="search px-2">
              <input
                type="text"
                className="form-control input"
                placeholder="Search user"
                value={search}
                onChange={filterUser}
              />
            </div>
            <ul className="list">
              {members?.map((member) => (
                <li key={member.id} onClick={() => showUserStats(member.id)}>
                  <div className="user-wrapper">
                    {member?.image ? (
                      <img
                        src={`${BASE_URL_MEDIA}/storage/assets/uploads/${member?.image}`}
                      />
                    ) : (
                      <div className="placerholder-small">
                        {member?.name.slice(0, 1)}
                      </div>
                    )}
                    <span className="name">{member?.name}</span>
                  </div>
                </li>
              ))}
            </ul>
            {pageCount > 1 && (
              <div
                style={{
                  float: "right",
                  marginTop: "20px",
                  marginRight: "10px",
                }}
              >
                <nav aria-label="Page navigation example">
                  <ReactPaginate
                    className="pagination pull-right"
                    breakLabel="..."
                    nextLabel=">"
                    onPageChange={handlePageClick}
                    pageRangeDisplayed={5}
                    pageCount={pageCount}
                    previousLabel="< "
                    activeClassName="active"
                    renderOnZeroPageCount={false}
                  />
                </nav>
              </div>
            )}
          </div>
        </div>
      )}

      {/* Activity members modal */}
      {activityModal && (
        <div className="trainer-modal-eventWrapper">
          <div className="trainer-modal">
            <div className="close" onClick={() => setActivityModal(false)}>
              <i className="fa fa-times"></i>
            </div>
            <div className="search px-2">
              <input
                type="text"
                className="form-control input"
                placeholder="Search user"
                value={searcha}
                onChange={filterActivityUser}
              />
            </div>
            <ul className="list">
              {activitymembers?.map((member) => (
                <li
                  key={member.id}
                  onClick={() => showUserStats(member.user.id)}
                >
                  <div className="user-wrapper">
                    {member?.user?.image ? (
                      <img
                        src={`${BASE_URL_MEDIA}/storage/assets/uploads/${member?.user?.image}`}
                      />
                    ) : (
                      <div className="placerholder-small">
                        {member?.user?.name.slice(0, 1)}
                      </div>
                    )}
                    <span className="name">{member?.user?.name}</span>
                  </div>
                </li>
              ))}
            </ul>
            {pageCounta > 1 && (
              <div
                style={{
                  float: "right",
                  marginTop: "20px",
                  marginRight: "10px",
                }}
              >
                <nav aria-label="Page navigation example">
                  <ReactPaginate
                    className="pagination pull-right"
                    breakLabel="..."
                    nextLabel=">"
                    onPageChange={handlePageClickActivity}
                    pageRangeDisplayed={5}
                    pageCount={pageCounta}
                    previousLabel="< "
                    activeClassName="active"
                    renderOnZeroPageCount={false}
                  />
                </nav>
              </div>
            )}
          </div>
        </div>
      )}
      {isLoading && (
        <div className="loaderparent">
          <div className="loader"></div>
        </div>
      )}
      <div className="row">
        {groups?.map((group) => (
          <div className="col-12 mb-3">
            <div className="group-card">
              <div className="group-header"
              style={{ cursor: 'pointer' }} onClick={() => showGroupProfile(group?.id ?? 0)}
              >
                {group?.image ? (
                  <img
                    src={getImageUrl(group?.image, BASE_URL_MEDIA)}
                  />
                ) : (
                  <img src={gymgirl} />
                )}

                <div className="info">
                  <p className="title">{group?.title}</p>

                  <p className="subtitle">{group?.group_type}</p>
                </div>
              </div>
              {group?.members && (
                <div className="users-wrapper">
                  {group?.members?.slice(0, 5).map((member) =>
                    member?.member?.image ? (
                      <img
                        onClick={() => getGroupMembers(group?.id)}
                        src={getImageUrl(member?.member?.image, BASE_URL_MEDIA)}
                        alt=""
                        srcset=""
                      />
                    ) : (
                      <div
                        className="placerholder-small"
                        onClick={() => getGroupMembers(group?.id)}
                      >
                        {member?.member?.name.slice(0, 1)}
                      </div>
                    )
                  )}
                  {group?.members?.length > 5 && (
                    <div
                      onClick={() => getGroupMembers(group?.id)}
                      className="last-user"
                    >
                      {" "}
                      + {group?.members?.length - 5}{" "}
                    </div>
                  )}
                </div>
              )}

              {group?.activities?.listing?.length > 0 && (
                <div className="activities-wrapper">
                  {group?.activities?.listing?.map((activity) => (
                    <div className="activity">
                      <p className="title">{activity?.title}</p>
                      <ul className="stats">
                        {activity?.checkins_count > 0 ? (
                          <li
                            className="pointer"
                            onClick={() => getActivityMembers(activity?.id)}
                          >
                            {" "}
                            <i class="fa-solid fa-people-group"></i>{" "}
                            {activity?.checkins_count}{" "}
                            {activity?.totalCapacity > 0 && (
                              <span>/ {activity?.totalCapacity}</span>
                            )}{" "}
                          </li>
                        ) : (
                          <li>
                            {" "}
                            <i class="fa-solid fa-people-group"></i>{" "}
                            {activity?.checkins_count}{" "}
                            {activity?.totalCapacity > 0 && (
                              <span>/ {activity?.totalCapacity}</span>
                            )}{" "}
                          </li>
                        )}

                        <li>
                          {" "}
                          <i class="fa-regular fa-calendar-days"></i>{" "}
                          {activity?.date.slice(0, 10)}
                        </li>
                        <li>
                          <i class="fa-regular fa-clock"></i>{" "}
                          {activity?.created_at.slice(0, 10)}
                        </li>
                        <li>
                          <i class="fa-regular fa-clock"></i>{" "}
                          <a
                            href={`https://www.google.com/maps?q=${activity?.location}`}
                            target="_blank"
                          >
                            Location
                          </a>
                        </li>
                      </ul>
                      <p className="description">
                        {activity?.description.slice(0, 39)}
                      </p>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TrainerGroups;
